import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEyeAlt = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2 9.3335C2 6.01979 4.68629 3.3335 8 3.3335C11.3137 3.3335 14 6.01979 14 9.3335M11.3333 9.3335C11.3333 11.1744 9.84095 12.6668 8 12.6668C6.15905 12.6668 4.66667 11.1744 4.66667 9.3335C4.66667 7.49255 6.15905 6.00016 8 6.00016C9.84095 6.00016 11.3333 7.49255 11.3333 9.3335Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgEyeAlt;
